import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-column pl-2 pr-2" }
const _hoisted_2 = { class: "mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "" }, "UŽÍVATELIA", -1)
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, { to: "/admin/users/0" }, {
        default: _withCtx(() => [
          _createVNode(_component_PrimevueButton, {
            label: "Pridať užívateľa",
            severity: "success",
            icon: "pi pi-plus",
            text: "",
            raised: "",
            class: "uppercase"
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_DataTable, {
      scrollable: "",
      scrollHeight: `${this.vh - 290}px`,
      value: this.users,
      stripedRows: "",
      "row-hover": "",
      selection: this.selectedUser,
      "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => ((this.selectedUser) = $event)),
      selectionMode: "single",
      metaKeySelection: false,
      onRowSelect: _cache[1] || (_cache[1] = ($event: any) => ($options.editUser(this.selectedUser.id))),
      tableStyle: "width: 100%",
      virtualScrollerOptions: { itemSize: 40 }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "lastName",
          header: "Užívateľ",
          style: {"min-width":"18%"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.data.lastName) + " " + _toDisplayString(slotProps.data.firstName), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "company",
          header: "Spoločnosť",
          style: {"min-width":"18%"}
        }),
        _createVNode(_component_Column, {
          field: "department.name",
          header: "Oddelenie",
          style: {"min-width":"18%"}
        }),
        _createVNode(_component_Column, {
          field: "email",
          header: "Email",
          style: {"min-width":"18%"}
        }),
        _createVNode(_component_Column, {
          field: "phone",
          header: "Telefón",
          style: {"min-width":"18%"}
        }),
        _createVNode(_component_Column, {
          field: "admin",
          header: "Admin",
          style: {"min-width":"18%"}
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.admin === true)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Správca"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, { header: "" }, {
          body: _withCtx((slotProps) => [
            _withDirectives(_createVNode(_component_PrimevueButton, {
              type: "button",
              icon: "pi pi-pencil",
              onClick: ($event: any) => ($options.editUser(slotProps.data.id)),
              text: "",
              size: "small"
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                { value: 'Editácia užívateľa' },
                void 0,
                { top: true }
              ]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["scrollHeight", "value", "selection"])
  ]))
}